import React from 'react'
import { Sun, Moon, Monitor, ChevronDown } from 'lucide-react'
import { useTheme, type ThemeMode } from '../context/ThemeContext'

const OPTIONS: { mode: ThemeMode; label: string; Icon: typeof Sun }[] = [
  { mode: 'system', label: 'System', Icon: Monitor },
  { mode: 'light', label: 'Light', Icon: Sun },
  { mode: 'dark', label: 'Dark', Icon: Moon },
]

/** Compact appearance selector for the header nav (System / Light / Dark). */
export default function ThemeToggle() {
  const { mode, theme, setMode } = useTheme()
  const [open, setOpen] = React.useState(false)
  const ref = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
    }
    document.addEventListener('mousedown', onDown)
    return () => document.removeEventListener('mousedown', onDown)
  }, [])

  const Active = mode === 'system' ? Monitor : mode === 'light' ? Sun : Moon

  return (
    <div className="theme-select" ref={ref}>
      <button
        type="button"
        className="theme-select-btn"
        aria-label="Appearance"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <Active size={16} />
        <ChevronDown size={13} className="theme-select-caret" />
      </button>
      {open && (
        <div className="theme-select-menu" role="menu">
          {OPTIONS.map(({ mode: m, label, Icon }) => (
            <button
              key={m}
              type="button"
              role="menuitemradio"
              aria-checked={mode === m}
              className={mode === m ? 'active' : undefined}
              onClick={() => {
                setMode(m)
                setOpen(false)
              }}
            >
              <Icon size={15} />
              <span>{label}{m === 'system' ? ` (${theme})` : ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
